/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Themebadge2Inputs */

const zh_systemsettings_themebadge2 = /** @type {(inputs: Systemsettings_Themebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外观`)
};

const en_systemsettings_themebadge2 = /** @type {(inputs: Systemsettings_Themebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

const es_systemsettings_themebadge2 = /** @type {(inputs: Systemsettings_Themebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apariencia`)
};

/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Systemsettings_Themebadge2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_themebadge2 = /** @type {((inputs?: Systemsettings_Themebadge2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Themebadge2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_themebadge2(inputs)
	if (locale === "en") return en_systemsettings_themebadge2(inputs)
	return es_systemsettings_themebadge2(inputs)
});
export { systemsettings_themebadge2 as "systemSettings_themeBadge" }